import { render, staticRenderFns } from "./InstructionSlideItem.vue?vue&type=template&id=64e5d2c3&scoped=true&"
import script from "./InstructionSlideItem.vue?vue&type=script&lang=js&"
export * from "./InstructionSlideItem.vue?vue&type=script&lang=js&"
import style0 from "./InstructionSlideItem.vue?vue&type=style&index=0&id=64e5d2c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e5d2c3",
  null
  
)

export default component.exports